module.exports = __webpack_public_path__ + "img/font-case.59cc5df9.svg";